//dependecnies
import { SpringConfig, animated } from "@react-spring/web";
import React from "react";

//hooks
import useVerticalExpander from "../../../hooks/AnimationHooks/useVerticalExpander";

type VerticalExpanderProps = {
	/**
	 * Whether or not the expander is expanded
	 */
	isExpanded: boolean;
	/**
	 * The height of the expander when it is closed
	 */
	closedHeight?: number;
	/**
	 * The height of the expander when it is open overriding height of the content
	 */
	openHeightOverride?: number;
	/**
	 * content within expander
	 */
	children: React.ReactNode;
	/**
	 * Whether or not to animate the expander when it is initially rendered
	 * this is useful for when the expander is initially rendered with a height of 0
	 * and you want to initialize to animated height
	 */
	initialAnimate?: boolean;
	/**
	 * className to apply to the expander
	 */
	className?: string;
	/**
	 * Whether or not to disable animation
	 */
	disableAnimation?: boolean;

	/**
	 * spring config for the animation
	 */
	config?: SpringConfig;
};

const VerticalExpander = ({
	isExpanded,
	closedHeight = 0,
	openHeightOverride,
	className,
	children,
	initialAnimate = false,
	disableAnimation = false,
	config = { tension: 280, friction: 30, clamp: true },
}: VerticalExpanderProps) => {
	const { style, ref } = useVerticalExpander({
		isExpanded,
		closedHeight,
		openHeightOverride,
		initialAnimate,
		disableAnimation,
		config,
	});

	return (
		<animated.div style={{ overflow: "hidden", ...style }} className={className}>
			<div ref={ref} style={{ height: "100%" }}>
				{children}
			</div>
		</animated.div>
	);
};

export default VerticalExpander;
